export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  videoUrl: string;
  duration: string;
  views: number;
  comments: number;
  date: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，疑似新恋情曝光",
    excerpt: "据知情人士透露，该男星近日多次被拍到与同一女子同行，两人举止亲密，引发粉丝热议...",
    content: `<p>近日，有网友在某高档小区附近偶遇当红男星王某，拍到他与一位神秘女子深夜同行。据目击者描述，两人有说有笑，举止亲密，随后一同进入了某小区。</p><p>据悉，这位神秘女子并非圈内人，而是一位金融行业的精英。两人据说是通过朋友介绍认识的，已经交往了约三个月。</p><p>该男星此前一直以单身形象示人，粉丝们对此反应强烈。有粉丝表示"只要是哥哥喜欢的我们就支持"，也有部分粉丝表示难以接受。</p><p>目前，该男星的工作室尚未对此事做出回应。</p>`,
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20walking%20with%20mysterious%20woman%20at%20night%20street%20scene%2C%20paparazzi%20style%20photography%2C%20blurry%20background%20with%20neon%20city%20lights%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20warm%20amber%20and%20dark%20tones&width=800&height=450&seq=article-01&orientation=landscape",
    videoUrl: "",
    duration: "03:25",
    views: 1283000,
    comments: 5621,
    date: "2026-08-03",
    tags: ["顶流男星", "恋情曝光", "深夜密会"],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: "某女星直播带货翻车，被质疑虚假宣传遭网友怒怼",
    excerpt: "该女星在直播中宣称某产品具有神奇功效，却被专业人士当场打脸，场面一度十分尴尬...",
    content: `<p>昨日晚间，知名女星李某在其直播间带货一款护肤品时，声称该产品"使用一周就能让皮肤年轻十岁"。这一言论立即引发了观看直播的专业皮肤科医生的质疑。</p><p>该医生在评论区指出，任何护肤品都不可能在短时间内实现如此夸张的效果，这种宣传涉嫌虚假宣传。随后，大量网友涌入评论区，纷纷指责该女星"为了赚钱没有底线"。</p><p>面对质疑，该女星先是试图辩解，随后在直播中情绪失控，一度落泪。最终，品牌方紧急叫停了直播。</p><p>目前，相关监管部门已介入调查此事。</p>`,
    category: "网红八卦",
    categorySlug: "wanghong-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=female%20celebrity%20live%20streaming%20selling%20products%20in%20studio%20with%20ring%20light%2C%20upset%20expression%2C%20dramatic%20lighting%2C%20warm%20tone%20indoor%20setting%2C%20cinematic%20documentary%20style&width=800&height=450&seq=article-02&orientation=landscape",
    videoUrl: "",
    duration: "05:12",
    views: 956000,
    comments: 4320,
    date: "2026-08-03",
    tags: ["直播翻车", "虚假宣传", "带货"],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: "某综艺节目录制现场爆发激烈冲突，导演组紧急叫停",
    excerpt: "据悉，两位嘉宾因游戏环节产生矛盾，从口角升级为肢体冲突，现场一度混乱...",
    content: `<p>据现场工作人员爆料，在某热门综艺最新一期录制过程中，两位常驻嘉宾因游戏环节的胜负判定问题产生了严重分歧。</p><p>起初两人只是口头争执，但随着情绪升级，其中一位嘉宾突然推了对方一把，导致矛盾彻底爆发。现场工作人员和导演组紧急介入，暂停了录制。</p><p>该节目此前一直以"嘉宾关系融洽"作为宣传点，此次事件无疑给节目形象带来了负面影响。节目组目前已发布声明称"正在积极协调处理"。</p>`,
    category: "综艺剧幕",
    categorySlug: "zongyi-jumu",
    thumbnail: "https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20scene%20with%20two%20people%20arguing%2C%20dramatic%20tension%2C%20stage%20lights%20and%20cameras%2C%20crew%20members%20intervening%2C%20warm%20studio%20lighting%2C%20documentary%20style&width=800&height=450&seq=article-03&orientation=landscape",
    videoUrl: "",
    duration: "02:48",
    views: 756000,
    comments: 3890,
    date: "2026-08-02",
    tags: ["综艺录制", "嘉宾冲突", "节目停录"],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "两大小花粉丝互撕升级，工作室被迫发布律师函",
    excerpt: "两位当红小花的粉丝因为番位之争在社交平台上掀起骂战，双双登上热搜...",
    content: `<p>近日，即将合作出演新剧的两位当红小花赵某和孙某，因为番位问题引发了各自粉丝之间的激烈争论。</p><p>双方粉丝在社交平台上互相攻击，从质疑对方偶像的演技、外貌，到翻出各种"黑历史"，骂战持续升级。相关话题阅读量已突破5亿。</p><p>最终，两位艺人的工作室分别发布了律师函，警告部分网友停止造谣和人身攻击。业内人士表示，这种饭圈乱象已经严重影响了行业生态。</p>`,
    category: "饭圈撕逼",
    categorySlug: "fenquan-sibi",
    thumbnail: "https://readdy.ai/api/search-image?query=two%20young%20Chinese%20actresses%20facing%20each%20other%20with%20tension%2C%20dramatic%20split%20lighting%2C%20red%20and%20blue%20contrast%2C%20fashion%20editorial%20style%2C%20dark%20background%2C%20cinematic%20composition&width=800&height=450&seq=article-04&orientation=landscape",
    videoUrl: "",
    duration: "04:35",
    views: 1820000,
    comments: 12800,
    date: "2026-08-02",
    tags: ["小花互撕", "番位之争", "律师函"],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: "某知名导演被曝片场耍大牌，多名演员控诉其恶劣行径",
    excerpt: "数位曾与该导演合作的演员匿名爆料，称其在片场动辄辱骂演员，行为令人发指...",
    content: `<p>近日，多位曾与知名导演张某合作过的演员通过匿名渠道爆料，揭露了该导演在片场的种种"耍大牌"行为。</p><p>据爆料者称，该导演在片场经常无故辱骂演员，有时甚至长达数小时。一位女演员表示，自己曾因为一个镜头的表情不到位，被导演当众羞辱了整整一个下午。</p><p>此外，该导演还被指控随意更改剧本、无视演员身体状况强行拍摄等。目前，已有业内组织表示将对此事进行调查。</p>`,
    category: "娱乐内幕",
    categorySlug: "yule-neimu",
    thumbnail: "https://readdy.ai/api/search-image?query=film%20director%20yelling%20on%20movie%20set%2C%20dramatic%20scene%20with%20film%20crew%2C%20angry%20expression%2C%20dark%20moody%20lighting%2C%20behind%20the%20scenes%20documentary%20photography%2C%20warm%20and%20shadow%20contrast&width=800&height=450&seq=article-05&orientation=landscape",
    videoUrl: "",
    duration: "06:20",
    views: 645000,
    comments: 2980,
    date: "2026-08-01",
    tags: ["知名导演", "耍大牌", "片场霸凌"],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: "某男团成员疑似恋爱中，粉丝发现多处证据",
    excerpt: "眼尖的粉丝从该成员的社交动态中发现了疑似恋爱的蛛丝马迹，引发广泛讨论...",
    content: `<p>近日，某当红男团成员金某被粉丝发现疑似正在恋爱中。粉丝们从多个细节中找到了"证据"：同款手链、相似的拍照背景、以及社交平台上若隐若现的互动。</p><p>其中最引人注目的是，该成员在最近一次直播中，背景中疑似出现了一个女生的声音。虽然成员迅速关闭了直播，但已经有粉丝录屏保存。</p><p>对此，该男团所属经纪公司表示"艺人私生活不便回应"。而粉丝们的反应则分为两派，一派表示祝福，另一派则要求"给个说法"。</p>`,
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=young%20Korean%20style%20male%20idol%20looking%20at%20phone%20with%20mysterious%20smile%2C%20cozy%20apartment%20setting%2C%20soft%20warm%20lighting%2C%20candid%20photography%20style%2C%20intimate%20mood&width=800&height=450&seq=article-06&orientation=landscape",
    videoUrl: "",
    duration: "02:55",
    views: 890000,
    comments: 6700,
    date: "2026-08-01",
    tags: ["男团成员", "疑似恋爱", "粉丝发现"],
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: "某网红自曝年入千万，引发网友质疑收入来源",
    excerpt: "该网红在短视频中炫耀自己的豪宅和豪车，声称年收入破千万，却遭到网友深扒...",
    content: `<p>近日，拥有500万粉丝的网红陈某在短视频中展示了自己的豪宅和豪车，并声称自己"年收入轻松破千万"。这段视频迅速引发了网友的热议。</p><p>然而，很快就有网友对该网红的收入来源提出了质疑。有网友扒出，该网红此前多次因虚假宣传被平台处罚，且其带货产品的质量屡遭投诉。</p><p>更有网友发现，该网红的"豪宅"实际上是租来的样板间。面对质疑，该网红删除了相关视频，但未做出正面回应。</p>`,
    category: "网红八卦",
    categorySlug: "wanghong-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20influencer%20showing%20off%20luxury%20car%20and%20mansion%2C%20ostentatious%20lifestyle%2C%20golden%20hour%20lighting%2C%20wealth%20display%2C%20modern%20villa%20exterior%2C%20warm%20sunset%20tones&width=800&height=450&seq=article-07&orientation=landscape",
    videoUrl: "",
    duration: "04:10",
    views: 1100000,
    comments: 8900,
    date: "2026-07-31",
    tags: ["网红炫富", "年入千万", "网友质疑"],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: "某知名歌手被曝抄袭国外作品，工作室火速回应",
    excerpt: "有网友指出该歌手最新单曲与某国外歌曲高度相似，对比视频引发轩然大波...",
    content: `<p>近日，知名歌手刘某发布的最新单曲《星空》被网友指出，与某国外歌手去年发布的一首歌曲在旋律上高度相似。</p><p>有音乐博主制作了两首歌的对比视频，从旋律走向、和声编排等多个角度进行了分析，称"相似度超过80%"。该视频发布后迅速获得百万播放量。</p><p>面对质疑，该歌手的工作室火速发布声明，称"已委托专业音乐人进行鉴定，将依法维护合法权益"。但网友们似乎并不买账，相关讨论仍在持续发酵。</p>`,
    category: "娱乐内幕",
    categorySlug: "yule-neimu",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20singer%20in%20recording%20studio%20with%20headphones%2C%20dramatic%20lighting%2C%20sheet%20music%20on%20stand%2C%20professional%20music%20production%20environment%2C%20warm%20moody%20atmosphere&width=800&height=450&seq=article-08&orientation=landscape",
    videoUrl: "",
    duration: "03:40",
    views: 720000,
    comments: 4500,
    date: "2026-07-31",
    tags: ["知名歌手", "抄袭风波", "工作室回应"],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: "某选秀节目选手被曝整容，前后对比照差距惊人",
    excerpt: "该选手在节目中以纯天然美貌吸粉无数，却被网友扒出整容前的照片...",
    content: `<p>在某热门选秀节目中人气飙升的选手林某，一直以"纯天然美女"的形象示人。然而，近日有网友扒出了她整容前的照片，前后对比之强烈令人惊讶。</p><p>从对比照来看，该选手的双眼皮、鼻梁、下巴都经历了明显的变化。网友们戏称"这不是整容，这是换头"。但也有人表示理解，认为"爱美之心人皆有之"。</p><p>该选手目前尚未对此事做出回应，但其社交账号已经关闭了评论功能。</p>`,
    category: "社交热事",
    categorySlug: "shejiao-reshi",
    thumbnail: "https://readdy.ai/api/search-image?query=young%20female%20talent%20show%20contestant%20on%20stage%20with%20spotlight%2C%20beautiful%20makeup%20and%20styling%2C%20dramatic%20stage%20lighting%2C%20performing%20arts%20atmosphere%2C%20soft%20glamour%20photography&width=800&height=450&seq=article-09&orientation=landscape",
    videoUrl: "",
    duration: "02:30",
    views: 1350000,
    comments: 10200,
    date: "2026-07-30",
    tags: ["选秀选手", "整容风波", "前后对比"],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: "某明星夫妻被传婚变，双方社交账号互相取关",
    excerpt: "这对曾经被称为娱乐圈模范夫妻的明星夫妇，近日被网友发现互相取关...",
    content: `<p>娱乐圈又一对明星夫妻传出婚变消息！近日，有细心的网友发现，演员张某和他的妻子、同为演员的李某在社交平台上互相取关了对方。</p><p>这对夫妻结婚已有八年，育有一子一女，一直被视为娱乐圈的模范夫妻。然而，近半年来两人公开互动明显减少，且多次被拍到独自出行。</p><p>有知情人士透露，两人其实已经分居数月，只是因为孩子和商业合约的原因暂未公开。目前，双方团队均未对此传闻做出回应。</p>`,
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20walking%20apart%20on%20red%20carpet%2C%20distant%20body%20language%2C%20formal%20attire%2C%20split%20composition%2C%20dramatic%20event%20lighting%2C%20paparazzi%20photography%20style&width=800&height=450&seq=article-10&orientation=landscape",
    videoUrl: "",
    duration: "04:50",
    views: 2100000,
    comments: 15600,
    date: "2026-07-30",
    tags: ["明星夫妻", "婚变传闻", "互相取关"],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: "某综艺主持人被曝私下歧视工作人员，视频流出",
    excerpt: "一段该主持人在后台训斥工作人员的视频在网络上疯传，言辞激烈引发众怒...",
    content: `<p>一段疑似某知名综艺主持人在后台训斥工作人员的视频近日在网络上疯传。视频中，该主持人对一位年轻的女性工作人员大声斥责，言辞激烈。</p><p>据现场人员透露，事情的起因仅仅是因为工作人员递错了话筒。该主持人却因此大发雷霆，持续训斥了近十分钟。</p><p>视频曝光后，该主持人的社交账号评论区迅速沦陷。大量网友表示"这种人根本不配做主持人"。截至目前，该主持人尚未对此事做出公开回应。</p>`,
    category: "综艺剧幕",
    categorySlug: "zongyi-jumu",
    thumbnail: "https://readdy.ai/api/search-image?query=TV%20host%20arguing%20angrily%20backstage%20at%20studio%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20of%20TV%20show%2C%20professional%20broadcast%20environment&width=800&height=450&seq=article-11&orientation=landscape",
    videoUrl: "",
    duration: "03:15",
    views: 980000,
    comments: 7800,
    date: "2026-07-29",
    tags: ["综艺主持", "歧视工作人员", "视频流出"],
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: "某网红直播带货保健品被曝无资质，监管部门介入",
    excerpt: "该网红在直播间大卖保健品，却被发现根本不具备相关销售资质...",
    content: `<p>近日，拥有300万粉丝的网红周某在直播中大量推销各种保健品，声称具有"神奇功效"。然而，有媒体调查发现，该网红根本不具备销售保健品的相关资质。</p><p>更令人担忧的是，该网红销售的保健品中有多款产品在国家药监局网站上查不到备案信息。有消费者反映，购买使用后出现了不良反应。</p><p>目前，当地市场监管部门已经介入调查。业内人士提醒消费者，购买保健品一定要认准正规渠道。</p>`,
    category: "网红八卦",
    categorySlug: "wanghong-bagua",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20influencer%20selling%20health%20supplements%20during%20live%20stream%2C%20colorful%20product%20bottles%20on%20table%2C%20studio%20with%20ring%20light%2C%20e-commerce%20livestream%20setting%2C%20warm%20indoor%20lighting&width=800&height=450&seq=article-12&orientation=landscape",
    videoUrl: "",
    duration: "05:30",
    views: 670000,
    comments: 3200,
    date: "2026-07-29",
    tags: ["直播带货", "无资质销售", "监管介入"],
    isHot: false,
    isNew: true,
  },
];